import { render, staticRenderFns } from "./FkinputPlus.vue?vue&type=template&id=2b4cd870&scoped=true"
import script from "./FkinputPlus.vue?vue&type=script&lang=js"
export * from "./FkinputPlus.vue?vue&type=script&lang=js"
import style0 from "./FkinputPlus.vue?vue&type=style&index=0&id=2b4cd870&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cd870",
  null
  
)

export default component.exports